module.exports = __webpack_public_path__ + "img/pinzhongzhuizong_extra_line.dbe5cad0.png";